module.exports = __webpack_public_path__ + "static/6305-woodrose-2-b610d3a6d18da53273b2d035a3167f8d.jpg";